import script from "./roleManagement.vue?vue&type=script&setup=true&lang=js"
export * from "./roleManagement.vue?vue&type=script&setup=true&lang=js"

import "./roleManagement.vue?vue&type=style&index=0&id=6e287a9f&lang=scss"

const __exports__ = script;

export default __exports__